import { createReducer } from '@reduxjs/toolkit';
import { ActionObject } from '../StoreConstants';
import { Types } from './Actions';
import INITIAL_STATE, { AuthenticationModalInitialState } from './InitialState';

const showAuthenticationModal = (state: AuthenticationModalInitialState, action: ActionObject) => ({
  ...state,
  ...action.payload,
});

const hideAuthenticationModal = (state: AuthenticationModalInitialState, action: ActionObject) => ({
  ...state,
  ...INITIAL_STATE,
});

export const AuthenticationModalReducer = createReducer(INITIAL_STATE, {
  [Types.SHOW_AUTHENTICATION]: showAuthenticationModal,
  [Types.HIDE_AUTHENTICATION]: hideAuthenticationModal,
});